import React from 'react';
import { Bike, Building, GraduationCap, Mail, Phone, Instagram } from 'lucide-react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-20 pb-10" data-id="element-101" data-mp="32ovxaurqktk5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102" data-mp="36pfufycb7x6a">
        {/* CTA Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-103" data-mp="3uf0p3ehtsive">
          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-104" data-mp="3uftmhouw9w0v">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-105" data-mp="37xvkgeim0i0">
              <GraduationCap className="w-6 h-6" data-id="element-106" data-mp="3qdf3n4r86w9l" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-107" data-mp="3qblxrrofsg2n">For Students</h3>
            <p className="text-slate-400 mb-6" data-id="element-108" data-mp="29y5g5yj5lgty">
              Ready to revolutionize your campus living experience? Join the
              waitlist today.
            </p>
            <Link to="/roommate-match" data-id="element-109" data-mp="3l9abhd1s8u1s">
              <Button className="w-full bg-brand-primary hover:bg-brand-light text-white border-none" data-id="element-110" data-mp="3labsrz9e6cry">
                Join Waitlist
              </Button>
            </Link>
          </div>

          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-111" data-mp="3v8rko4g8tq2i">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-112" data-mp="3q7u1ppnesrzy">
              <Bike className="w-6 h-6" data-id="element-113" data-mp="80xk4905f1jm" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-114" data-mp="32w2lsidfaa9">Become an Ambassador</h3>
            <p className="text-slate-400 mb-6" data-id="element-115" data-mp="htd1p57j9o3z">
              Join the Simba Fleet. Verify properties and earn money while you
              ride.
            </p>
            <Link to="/ambassadors" data-id="element-116" data-mp="cvtn246xb9bi">
              <Button variant="outline" className="w-full border-brand-primary/30 text-white hover:bg-brand-dark-secondary hover:text-white hover:border-brand-primary/50" data-id="element-117" data-mp="qt03hs46cvxk">
                Apply Now
              </Button>
            </Link>
          </div>

          <div className="bg-brand-dark-secondary/50 p-8 rounded-2xl border border-brand-primary/20" data-id="element-118" data-mp="ytoa64vnsjyf">
            <div className="w-12 h-12 bg-brand-primary/20 text-brand-primary rounded-xl flex items-center justify-center mb-6" data-id="element-119" data-mp="13t0v2k2yzgyd">
              <Building className="w-6 h-6" data-id="element-120" data-mp="18lk89fxqwa2n" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-121" data-mp="1cm466lq57hpu">For Landlords</h3>
            <p className="text-slate-400 mb-6" data-id="element-122" data-mp="1cnypjvlrn1rt">
              List your property to access verified tenants and automated rent
              collection.
            </p>
            <Link to="/login" data-id="element-123" data-mp="1mkbhop1nx7kg">
              <Button variant="outline" className="w-full border-brand-primary/30 text-white hover:bg-brand-dark-secondary hover:text-white hover:border-brand-primary/50" data-id="element-124" data-mp="1mhxs2vpr4nka">
                List Property
              </Button>
            </Link>
          </div>
        </div>

        {/* Links & Copyright */}
        <div className="border-t border-brand-primary/20 pt-10" data-id="element-125" data-mp="2afx2n01a495z">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-126" data-mp="25onbfv030xrz">
            {/* Logo & Contact */}
            <div data-id="element-127" data-mp="21maadjwa5o1j">
              <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-128" data-mp="21nv3r66uz0xt">
                <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-8 w-auto brightness-0 invert" data-id="element-129" data-mp="1wnz05822pbis" />
              </Link>
              <p className="text-slate-400 text-sm mb-4" data-id="element-130" data-mp="2pa9y0ayaoybw">
                Making student housing safer across Africa.
              </p>
              <div className="inline-flex items-center gap-3 bg-white rounded-xl px-3 py-2 mb-4" data-id="element-131" data-mp="2fegm8tseh8v6">
                <img src="https://cdn.magicpatterns.com/uploads/8iDDWdAud2hPPyMisCfFjJ/IMG_0021.png" alt="Federal Ministry of Education" className="h-7 w-auto" data-id="element-132" data-mp="18xutssxi2xo3" />
                <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 border-l border-slate-200 pl-3 leading-tight" data-id="element-133" data-mp="2ruxya7cuxmu1">
                  Backed by the
                  <br data-id="element-134" data-mp="2ivuef15v93eh" />
                  Federal Ministry
                </span>
              </div>
              <div className="space-y-2" data-id="element-135" data-mp="2ntcqh0f6jyqp">
                <a href="mailto:support@campusaparte.com" className="flex items-center gap-2 text-slate-400 hover:text-brand-primary transition-colors text-sm" data-id="element-136" data-mp="2nue0r2odgh7d">
                  <Mail className="w-4 h-4" data-id="element-137" data-mp="3fize81cd85jh" />
                  support@campusaparte.com
                </a>
                <a href="tel:+2347069243079" className="flex items-center gap-2 text-slate-400 hover:text-brand-primary transition-colors text-sm" data-id="element-138" data-mp="36kne98plzved">
                  <Phone className="w-4 h-4" data-id="element-139" data-mp="1v5gwi3gzwkxm" />
                  +234 706 924 3079
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-140" data-mp="1nk4o50pczirp">
              <h4 className="font-bold text-white mb-4" data-id="element-141" data-mp="1nnshnzut056f">Quick Links</h4>
              <div className="flex flex-col gap-2 text-sm text-slate-400" data-id="element-142" data-mp="1iml8bwd0ixxn">
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-143" data-mp="1wlkxd54fteuc">
                  About Us
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-144" data-mp="13x6ykn5iyehq">
                  How It Works
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-145" data-mp="1dobbzifjxrag">
                  Safety & Security
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-146" data-mp="l77eyfsgdrlp">
                  Blog
                </a>
              </div>
            </div>

            {/* Legal */}
            <div data-id="element-147" data-mp="2g9u71gom7ppi">
              <h4 className="font-bold text-white mb-4" data-id="element-148" data-mp="2gadjwizernwo">Legal</h4>
              <div className="flex flex-col gap-2 text-sm text-slate-400" data-id="element-149" data-mp="2l8otcslsjwed">
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-150" data-mp="2pzx1zmfardqh">
                  Terms of Service
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-151" data-mp="1xc17mod79xwv">
                  Privacy Policy
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-152" data-mp="279yv39n8jqof">
                  Cookie Policy
                </a>
                <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-153" data-mp="2b97pmgq3nsl1">
                  Support
                </a>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-brand-primary/20 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-154" data-mp="1b3lzt9dokd0z">
            <div className="text-sm text-slate-500" data-id="element-155" data-mp="172akbwoit86i">
              © {new Date().getFullYear()} CampusAparte. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm text-slate-400" data-id="element-156" data-mp="xc7g10by87sv">
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-157" data-mp="xbpeppafj3e3">
                Facebook
              </a>
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-158" data-mp="nd03uggyaj7c">
                Twitter
              </a>
              <a href="https://www.instagram.com/campusaparte/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-primary transition-colors flex items-center gap-1" data-id="element-159" data-mp="edmsfi99nkjz">
                <Instagram className="w-4 h-4" data-id="element-160" data-mp="28p9xdxlvh1e3" />
                Instagram
              </a>
              <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-161" data-mp="1hnv5600jhxtj">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}